import { combineReducers } from 'redux';
import { FAILED_COMPLETING_FORM, FETCHING_FORM, FORM_COMPLETED, FORM_COMPLETION_IN_PROGRESS, RESET_FORM_COMPLETION_STATUS, GET_FORM, GET_FORM_FAILED, RESET_FORM_CONTEXT } from '../actions/form';
const initialState = {
  loaded: false,
  error: false
};
const fetch = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case RESET_FORM_CONTEXT:
    case FETCHING_FORM:
      return {
        loaded: false,
        error: false
      };
    case GET_FORM:
      return {
        loaded: true,
        process: action.form.process,
        sections: action.form.sections,
        error: false
      };
    case GET_FORM_FAILED:
      return {
        loaded: false,
        error: true
      };
    default:
      return state;
  }
};
const completeForm = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    completed: false,
    failedDuringCompletion: false,
    formCompletionInProgress: false,
    kycStatus: undefined
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case RESET_FORM_COMPLETION_STATUS:
      return {
        completed: false,
        failedDuringCompletion: false,
        kycStatus: undefined,
        formCompletionInProgress: false
      };
    case FORM_COMPLETED:
      return {
        completed: true,
        failedDuringCompletion: false,
        kycStatus: action.status,
        formCompletionInProgress: false
      };
    case FAILED_COMPLETING_FORM:
      return {
        completed: false,
        failedDuringCompletion: true,
        formCompletionInProgress: false
      };
    case FORM_COMPLETION_IN_PROGRESS:
      return {
        completed: false,
        failedDuringCompletion: false,
        formCompletionInProgress: true
      };
    default:
      return state;
  }
};
export default combineReducers({
  fetch,
  completeForm
});